export default __webpack_public_path__ + "static/media/raya-2025-popup-banner.4b09adf2.jpg";